/* eslint-disable react/require-default-props */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import companyId from 'services/company_id';
import { ApplicationState } from 'store';
import { createBiddingManaged } from 'store/modules/bidding_store/actions';
import { createBulletinManaged } from 'store/modules/bulletins_store/actions';
import { createImminenceManaged } from 'store/modules/get_dados_imminence_store/actions';
import { createManaged } from 'store/modules/management_store/actions';
import { ProfileState } from 'store/modules/profile_store/types';
import createTrack from 'services/actions/tracker_actions';
import { track } from 'services/tracking';
import iconUserBlue from 'assets/images/user-icon-blue.svg';
import { BiddingData } from 'store/modules/bidding_store/types';
import { BulletinBiddingsTypes } from 'store/modules/bulletins_store/types';
import { Container } from './styles';

interface ManagementButtonProps {
  bidding?: BiddingData | BulletinBiddingsTypes;
  biddingId: number;
  setModalManagementTaskOpened: React.Dispatch<React.SetStateAction<boolean>>;
  setModalFinishBiddingOpened?: React.Dispatch<React.SetStateAction<boolean>> | null;
  setModalRemoveBiddingOpened?: React.Dispatch<React.SetStateAction<boolean>> | null;
  setTaskType: React.Dispatch<React.SetStateAction<string>>;
  isManaged: boolean;
  totalOpenedTasks?: number;
  source?: string;
  setCurrentBiddingId?: React.Dispatch<React.SetStateAction<number>> | null;
  setCurrentBiddingTotalOpenedTasks?: React.Dispatch<React.SetStateAction<number>> | null;
  bulletinId?: number;
}

const ManagementButton = (props: ManagementButtonProps) => {
  const {
    bidding,
    biddingId,
    setModalManagementTaskOpened,
    setModalFinishBiddingOpened,
    setModalRemoveBiddingOpened,
    setTaskType,
    isManaged,
    totalOpenedTasks = 0,
    source = 'biddings',
    setCurrentBiddingId = null,
    setCurrentBiddingTotalOpenedTasks = null,
    bulletinId = 0,
  } = props;

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const dispatch = useDispatch();

  const activateManaged = () => {
    createTrack('Gestão de Licitações - Adicionou/retirou uma licitação do Gerenciamento');
    createTrack('Card - Adicinou ao gerenciar', { fonte: source, bidding_id: biddingId });
    track('gestao.adicionou', { fonte: source, bidding_id: biddingId });
    if (source === 'management') return dispatch(createManaged(biddingId, companyId(profile)));
    if (source === 'imminence')
      return dispatch(createImminenceManaged(biddingId, companyId(profile)));
    if (source === 'bulletin')
      return dispatch(createBulletinManaged(biddingId, bulletinId, companyId(profile)));
    return dispatch(createBiddingManaged(biddingId, companyId(profile)));
  };
  const formatNames = (names: string[]) => {
    if (names.length === 0) return '';
    if (names.length === 1) return names[0];
    if (names.length === 2) return `${names[0]} e ${names[1]}`;

    return `${names.slice(0, -1).join(', ')} e ${names[names.length - 1]}`;
  };

  const namesArray = bidding?.managers?.map((m) => m.name) || [];
  const names = formatNames(namesArray) || 'Nenhum membro do time gerenciando essa licitação';

  const manageBiddingButton = () => {
    return (
      <Container>
        <button
          type="button"
          className="btn btn-sm btn-primary tour-management-btn d-flex align-items-center"
          onClick={() => activateManaged()}
        >
          Gerenciar licitação
          {bidding?.managers?.length !== 0 && source !== 'imminence' && (
            <div
              className="databalloon managers d-flex ml-2"
              data-balloon-length="medium"
              aria-label={`Gerenciado por: ${names}`}
            >
              <img className="icon-user" src={iconUserBlue} alt="icone de usuário" />
              <span className="managers-length">{bidding?.managers?.length}</span>
            </div>
          )}
        </button>
      </Container>
    );
  };

  const accessBiddingButton = () => {
    return (
      <>
        {!isManaged ? (
          <>
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              key="btn-add-management-bidding"
              onClick={() => activateManaged()}
            >
              Gerenciar licitação
            </button>
            <button
              type="button"
              className="btn btn-sm btn-secondary dropdown-toggle dropdown-toggle-split mt-1 mt-md-0"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span className="sr-only">Toggle Dropdown</span>
            </button>
          </>
        ) : (
          <>
            <Container>
              <Link
                target="_blank"
                className="btn btn-sm btn-primary tour-access-btn d-flex align-items-center"
                to={`/minhas_licitacoes/management/${biddingId}/${companyId(profile)}`}
                onClick={() => {
                  createTrack('Card - Acessou licitação', { fonte: source });
                  track('licitacao.acessou_licitacao', { fonte: source, bidding_id: biddingId });
                }}
              >
                Acessar a licitação
                {bidding?.managers?.length !== 0 &&
                  source !== 'management' &&
                  source !== 'imminence' && (
                    <div
                      className="databalloon managers d-flex ml-2"
                      data-balloon-length="medium"
                      aria-label={`Gerenciado por: ${names}`}
                    >
                      <img className="icon-user" src={iconUserBlue} alt="icone de usuário" />
                      <span className="managers-length">{bidding?.managers?.length}</span>
                    </div>
                  )}
              </Link>
            </Container>
            <button
              type="button"
              className="btn btn-sm btn-primary dropdown-toggle dropdown-toggle-split"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span className="sr-only">Toggle Dropdown</span>
            </button>
          </>
        )}

        <div className="dropdown-menu">
          <button
            type="button"
            className="dropdown-item"
            key="btn-add-task"
            data-toggle="modal"
            data-target="#modal"
            onClick={() => {
              if (setCurrentBiddingId) setCurrentBiddingId(biddingId);
              setTaskType('task');
              setModalManagementTaskOpened(true);
              createTrack('Card - Adicinou tarefa', { fonte: source });
            }}
          >
            Adicionar Tarefa
          </button>
          <button
            type="button"
            className="dropdown-item"
            key="btn-add-progress"
            data-toggle="modal"
            data-target="#modal"
            onClick={() => {
              if (setCurrentBiddingId) setCurrentBiddingId(biddingId);
              setTaskType('progress');
              setModalManagementTaskOpened(true);
              createTrack('Card - Adicinou andamento', { fonte: source });
            }}
          >
            Adicionar Andamento
          </button>
          {!isManaged ? (
            <Link
              target="_blank"
              className="dropdown-item"
              to={`/minhas_licitacoes/management/${biddingId}/${companyId(profile)}`}
              onClick={() => {
                createTrack('Card - Acessou licitação', { fonte: source });
                track('licitacao.acessou_licitacao', { fonte: source, bidding_id: biddingId });
              }}
            >
              Acessar a licitação
            </Link>
          ) : (
            <button
              type="button"
              className="dropdown-item"
              key="btn-remove-management"
              onClick={() => {
                setCurrentBiddingId && setCurrentBiddingId(biddingId);
                setCurrentBiddingTotalOpenedTasks &&
                  setCurrentBiddingTotalOpenedTasks(totalOpenedTasks);
                setModalRemoveBiddingOpened && setModalRemoveBiddingOpened(true);
                createTrack('Card - Removeu do gerenciar', {
                  fonte: source,
                  bidding_id: biddingId,
                });
              }}
            >
              Remover do Gerenciamento
            </button>
          )}

          {source === 'management' && (
            <button
              type="button"
              className="dropdown-item"
              key="btn-finish-bidding"
              onClick={() => {
                setCurrentBiddingId && setCurrentBiddingId(biddingId);
                setCurrentBiddingTotalOpenedTasks &&
                  setCurrentBiddingTotalOpenedTasks(totalOpenedTasks);
                setModalFinishBiddingOpened && setModalFinishBiddingOpened(true);
              }}
            >
              Finalizar
            </button>
          )}
        </div>
      </>
    );
  };

  if (source === 'management') return <div className="btn-group">{accessBiddingButton()}</div>;
  return (
    <div className="btn-group mr-1 mb-1">
      {isManaged && source !== 'management' ? accessBiddingButton() : manageBiddingButton()}
    </div>
  );
};

export default ManagementButton;
